export default "__VITE_ASSET__dJRqgjeP__"